import React from 'react';
import { Container, Card } from 'Common';
import { Wrapper, Grid, Item, Content, SkillImg } from './styles';

const skills = [
  {
    name: 'React',
    img: '/icons/skills/react.svg',
  },
  {
    name: 'Redux',
    img: '/icons/skills/redux.svg',
  },
  {
    name: 'Next.js',
    img: '/icons/skills/nextjs.svg',
  },
  {
    name: 'Typescript',
    img: '/icons/skills/typescript-icon.svg',
  },
  {
    name: 'Tailwind CSS',
    img: '/icons/skills/tailwindcss-icon.svg',
  },
  {
    name: 'Sass',
    img: '/icons/skills/sass.svg',
  },
  {
    name: 'Jest',
    img: '/icons/skills/jest.svg',
  },
  {
    name: 'Framer Motion',
    img: '/icons/skills/framer-motion.png',
  },
  {
    name: 'Expo',
    img: '/icons/skills/expo.svg',
  },
  {
    name: 'Node.js',
    img: '/icons/skills/nodejs.svg',
  },
  {
    name: 'Elixir',
    img: '/icons/skills/elixir-icon.png',
  },
  {
    name: 'ESLint',
    img: '/icons/skills/eslint.svg',
  },
  {
    name: 'Docusaurus',
    img: '/icons/skills/docusaurus.svg',
  },
  {
    name: 'Apiary',
    img: '/icons/skills/apiary.svg',
  },
  {
    name: 'Netlify',
    img: '/icons/skills/netlify.svg',
  },
];

export const Skills = () => {
  return (
    <Wrapper as={Container} id="skills">
      <h2>Skills & Technologies</h2>
      <Grid>
        {skills.map((skill, i) => (
          <Item key={i}>
            <Card>
              <Content style={{ textAlign: 'center' }}>
                <SkillImg src={skill.img} />
                <h4>{skill.name}</h4>
              </Content>
            </Card>
          </Item>
        ))}
      </Grid>
    </Wrapper>
  );
};
